// Generated by purs version 0.14.3
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Ring_Module = require("../Data.Ring.Module/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Value = function (x) {
    return x;
};
var TokenUnit = function (fromMinorUnit, toMinorUnit) {
    this.fromMinorUnit = fromMinorUnit;
    this.toMinorUnit = toMinorUnit;
};
var ProxyTU = (function () {
    function ProxyTU() {

    };
    ProxyTU.value = new ProxyTU();
    return ProxyTU;
})();
var TokenUnitSpec = function (divider) {
    this.divider = divider;
};
var unitSpecNoPay = new TokenUnitSpec(Data_Function["const"](Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber)));
var unValue = function (v) {
    return v;
};
var unitTokenUnitSpec = function (dictTokenUnitSpec) {
    return new TokenUnit(Value, unValue);
};
var toMinorUnit = function (dict) {
    return dict.toMinorUnit;
};
var showValue = Network_Ethereum_Core_BigNumber.showBigNumber;
var semigroupTokenUnitSpec = function (dictTokenUnitSpec) {
    return new Data_Semigroup.Semigroup(function (a) {
        return function (b) {
            return Data_Semiring.add(Network_Ethereum_Core_BigNumber.semiringBigNumber)(unValue(a))(unValue(b));
        };
    });
};
var fromMinorUnit = function (dict) {
    return dict.fromMinorUnit;
};
var eqValue = Network_Ethereum_Core_BigNumber.eqBigNumber;
var encodeValue = new Foreign_Generic_Class.Encode(function (v) {
    return Foreign_Generic_Class.encode(Network_Ethereum_Core_BigNumber.encodeBigNumber)(v);
});
var encodeNoPay = new Foreign_Generic_Class.Encode(function (v) {
    return Foreign_Generic_Class.encode(Network_Ethereum_Core_BigNumber.encodeBigNumber)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber));
});
var divider = function (dict) {
    return dict.divider;
};
var formatValue = function (dictTokenUnitSpec) {
    return function (v) {
        return Data_Show.show(Network_Ethereum_Core_BigNumber.showBigNumber)(Network_Ethereum_Core_BigNumber.divide(toMinorUnit(unitTokenUnitSpec(dictTokenUnitSpec))(v))(divider(dictTokenUnitSpec)(ProxyTU.value)));
    };
};
var mkValue = function (dictTokenUnitSpec) {
    var $26 = Data_Semiring.mul(Network_Ethereum_Core_BigNumber.semiringBigNumber)(divider(dictTokenUnitSpec)(ProxyTU.value));
    return function ($27) {
        return Value(Network_Ethereum_Core_BigNumber.floorBigNumber($26($27)));
    };
};
var modukeTokenUnitSpec = function (dictTokenUnitSpec) {
    return new Data_Ring_Module.LeftModule(function () {
        return Data_Ring.ringInt;
    }, function (v) {
        return function (v1) {
            return Value(Data_Semiring.add(Network_Ethereum_Core_BigNumber.semiringBigNumber)(v)(v1));
        };
    }, function (a) {
        return function (v) {
            return Value(Data_Ring_Module.mmulL(Network_Ethereum_Core_BigNumber.bigNumberLModule)(a)(v));
        };
    }, function (v) {
        return function (v1) {
            return Value(Data_Ring.sub(Network_Ethereum_Core_BigNumber.ringBigNumber)(v)(v1));
        };
    }, mkValue(dictTokenUnitSpec)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber)));
};
var monoidTokenUnitSpec = function (dictTokenUnitSpec) {
    return new Data_Monoid.Monoid(function () {
        return semigroupTokenUnitSpec(dictTokenUnitSpec);
    }, mkValue(dictTokenUnitSpec)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber)));
};
var decodeValue = Network_Ethereum_Core_BigNumber.decodeBigNumber;
var createDivider = function (denomination) {
    return function (v) {
        var unsafeConvert = function (a) {
            return Data_Maybe.fromJust()(Network_Ethereum_Core_BigNumber.parseBigNumber(Data_Int.decimal)(a));
        };
        return unsafeConvert("1" + Data_String_Common.joinWith("")(Data_Unfoldable.replicate(Data_Unfoldable.unfoldableArray)(denomination)("0")));
    };
};
var unitSpecMinorUnit = new TokenUnitSpec(createDivider(0));
var unitSpecMinorUnitE12 = new TokenUnitSpec(createDivider(12));
var unitSpecMinorUnitE15 = new TokenUnitSpec(createDivider(15));
var unitSpecMinorUnitE18 = new TokenUnitSpec(createDivider(18));
var unitSpecMinorUnitE21 = new TokenUnitSpec(createDivider(21));
var unitSpecMinorUnitE3 = new TokenUnitSpec(createDivider(3));
var unitSpecMinorUnitE6 = new TokenUnitSpec(createDivider(6));
var unitSpecMinorUnitE9 = new TokenUnitSpec(createDivider(9));
var convert = function (dictTokenUnit) {
    return function (dictTokenUnit1) {
        var $28 = fromMinorUnit(dictTokenUnit1);
        var $29 = toMinorUnit(dictTokenUnit);
        return function ($30) {
            return $28($29($30));
        };
    };
};
module.exports = {
    TokenUnit: TokenUnit,
    fromMinorUnit: fromMinorUnit,
    toMinorUnit: toMinorUnit,
    TokenUnitSpec: TokenUnitSpec,
    divider: divider,
    ProxyTU: ProxyTU,
    convert: convert,
    formatValue: formatValue,
    mkValue: mkValue,
    eqValue: eqValue,
    showValue: showValue,
    decodeValue: decodeValue,
    encodeNoPay: encodeNoPay,
    encodeValue: encodeValue,
    semigroupTokenUnitSpec: semigroupTokenUnitSpec,
    monoidTokenUnitSpec: monoidTokenUnitSpec,
    modukeTokenUnitSpec: modukeTokenUnitSpec,
    unitTokenUnitSpec: unitTokenUnitSpec,
    unitSpecNoPay: unitSpecNoPay,
    unitSpecMinorUnit: unitSpecMinorUnit,
    unitSpecMinorUnitE3: unitSpecMinorUnitE3,
    unitSpecMinorUnitE6: unitSpecMinorUnitE6,
    unitSpecMinorUnitE9: unitSpecMinorUnitE9,
    unitSpecMinorUnitE12: unitSpecMinorUnitE12,
    unitSpecMinorUnitE15: unitSpecMinorUnitE15,
    unitSpecMinorUnitE18: unitSpecMinorUnitE18,
    unitSpecMinorUnitE21: unitSpecMinorUnitE21
};
